import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { RecoilRoot } from 'recoil';

import RootContainer from './containers/RootContainer';

import './App.css';

function App() {
  return (
    <RecoilRoot>
      <Router>
        <RootContainer />
        <ToastContainer hideProgressBar theme="colored" />
      </Router>
    </RecoilRoot>
  );
}

export default App;
